import React from "react";

/* Only a file named exactly `hero-background.mp4` / `.webm` is used — the rest
   of src/assets/video holds unrelated event footage. No such file means this
   renders nothing and the animated grid underneath shows through. */
const videoContext = require.context(
  "../../assets/video",
  false,
  /^\.\/hero-background\.(mp4|webm)$/
);

const SOURCE = videoContext.keys()[0];

const HeroVideoBackground = () => {
  if (!SOURCE) return null;

  return (
    <>
      {/* `object-cover` on an absolutely-filled video, not a CSS background:
          background-video can't be object-fitted and the legacy
          `.background-video` rule forced a 150vh height. */}
      <video
        className="absolute inset-0 z-[-2] w-full h-full object-cover opacity-60 pointer-events-none"
        src={videoContext(SOURCE)}
        autoPlay
        muted
        loop
        playsInline
        preload="metadata"
        aria-hidden="true"
        tabIndex={-1}
      />

      {/* Wash so the headline keeps its contrast over the brightest frames,
          fading to the page surface at the bottom edge. */}
      <span
        aria-hidden="true"
        className="absolute inset-0 z-[-2] bg-gradient-to-b from-[#131315]/75 via-[#131315]/70 to-[#131315] pointer-events-none"
      />
    </>
  );
};

export default HeroVideoBackground;
